import React from "react";

// w/o a fetchMore function this is essentially a noop
const useInfiniteScroll = (fetchMore, listElm) => {
  const scroll = () => {
    if (!listElm) return;
    if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
      fetchMore();
    }
  };

  React.useEffect(() => {
    if (!listElm || typeof fetchMore !== "function") return;
    listElm.addEventListener("scroll", scroll);
    return () => {
      listElm.removeEventListener("scroll", scroll);
    };
  }, [listElm, scroll, fetchMore]);
};

export default useInfiniteScroll;
